<template>
  <v-row justify="center">
    <v-dialog
      origin="top center"
      v-model="dialogStatus"
      persistent
      content-class="warranty-dialog"
      :max-width="dialogWidth"
    >
      <v-card>
        <v-card-title
          class="headline dialog-custom-header white-background custom-border-bottom custom-header-blue-text"
        >
          <template v-if="lodash.isEmpty(warrantyDetail) === false">
            Renew Warranty - {{ warrantyOption.unique_id }}
          </template>
          <template v-else>
            Renew Warranty - {{ warrantyOption.unique_id }}</template
          >
        </v-card-title>
        <v-card-text class="p-8 font-size-16">
          <perfect-scrollbar
            :options="{ suppressScrollX: true }"
            class="scroll"
            style="max-height: 90vh; position: relative"
          >
            <v-form
              ref="warrantyForm"
              v-model.trim="formValid"
              lazy-validation
              v-on:submit.stop.prevent="update_or_create"
            >
              <v-container fluid>
                <template>
                  <v-row>
                    <!-- <v-col md="12" class="py-0 mb-2">
                        <v-radio-group
                          v-model="warrantyOption.warranty_type"
                          row
                          disabled
                          hide-details
                          class="mt-0"
                        >
                          <v-radio
                            style="margin-right: -2px"
                            value="customer"
                            color="blue"
                            disabled
                          ></v-radio>
                          <v-chip
                            label
                            color="blue"
                            outlined
                            class="text-white p-3 mr-5"
                            small
                            >Customer</v-chip
                          >
                          <v-radio
                            value="equipment"
                            color="red"
                            disabled
                            style="margin-right: -2px"
                          ></v-radio>
                          <v-chip
                            label
                            color="red"
                            outlined
                            class="text-white p-3"
                            small
                            >Equipment</v-chip
                          >
                        </v-radio-group>
                      </v-col> -->

                    <v-col
                      md="6"
                      class="py-0"
                      v-if="warrantyOption?.customer > 0"
                    >
                      <label class="font-weight-600 ml-1">Customer </label>
                      <v-autocomplete
                        v-model.trim="warrantyOption.customer"
                        :items="allCustomerList"
                        clearable
                        dense
                        flat
                        filled
                        label="Display Name"
                        item-color="cyan"
                        color="cyan"
                        solo
                        disabled
                        :loading="pageLoading"
                        item-text="display_name"
                        item-value="id"
                      >
                        <template v-slot:no-data>
                          <v-list-item>
                            <v-list-item-title
                              v-html="'No Customer(s) Found.'"
                            ></v-list-item-title>
                          </v-list-item>
                        </template>
                        <template v-slot:item="{ item }">
                          <template>
                            <v-list-item-avatar>
                              <v-img
                                :lazy-src="$defaultProfileImage"
                                :src="$assetAPIURL(item.profile_logo)"
                                aspect-ratio="1"
                                class="margin-auto grey lighten-5 custom-grey-border"
                                transition="fade-transition"
                              ></v-img>
                            </v-list-item-avatar>
                            <v-list-item-content>
                              <v-list-item-title
                                class="text-capitalize font-weight-500 font-size-16"
                                >{{ item.display_name }}
                                <v-chip
                                  color="blue white--text"
                                  label
                                  class="ml-2"
                                  v-if="
                                    item.company_type &&
                                    item.company_type == 'company'
                                  "
                                >
                                  <span class="font-size-16 font-weight-500">
                                    Company
                                  </span>
                                </v-chip>
                                <v-chip
                                  color="red white--text"
                                  label
                                  class="ml-2"
                                  v-if="
                                    item.company_type &&
                                    item.company_type == 'personal'
                                  "
                                >
                                  <span class="font-size-16 font-weight-500">
                                    Individual
                                  </span>
                                </v-chip>
                              </v-list-item-title>
                              <v-list-item-title
                                class="text-capitalize font-weight-500 font-size-16"
                                >{{ item.company_name }}</v-list-item-title
                              >
                            </v-list-item-content>
                          </template>
                        </template>
                      </v-autocomplete>
                    </v-col>

                    <v-col
                      md="6"
                      class="py-0"
                      v-if="warrantyOption?.customer > 0"
                    >
                      <label class="font-weight-600 ml-1"
                        >Site Location {{ warrantyOption.warranty_type }}</label
                      >
                      <!-- v-on:change="getEquipment($event)" -->
                      <v-autocomplete
                        hide-details
                        clearable
                        id="property-equipment"
                        :items="allSiteLocationList"
                        v-on:change="getOptions($event, 'location')"
                        v-model.trim="warrantyOption.address"
                        disabled
                        dense
                        flat
                        filled
                        label="Site Location"
                        item-color="cyan"
                        color="cyan"
                        solo
                        :loading="pageLoading"
                        item-text="barcode"
                        item-value="id"
                      >
                        <template v-slot:no-data>
                          <v-list-item>
                            <v-list-item-title
                              v-html="'No Site Location(s) Found.'"
                            ></v-list-item-title>
                          </v-list-item>
                        </template>
                        <template v-slot:item="{ item }">
                          <v-list-item-icon class="mr-3">
                            <v-icon large>mdi-home-map-marker</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-layout style="max-width: 150px">
                              <v-flex>
                                <Barcode
                                  class="my-0 mt-0 mb-0 mr-1"
                                  :barcode="item.barcode"
                                ></Barcode>
                              </v-flex>
                              <v-flex v-if="item.is_tenant">
                                <v-chip
                                  class="mx-1"
                                  label
                                  small
                                  color="green"
                                  outlined
                                  >Tenant</v-chip
                                >
                              </v-flex>
                              <v-flex>
                                <v-chip
                                  label
                                  small
                                  class="ml-1"
                                  :color="item.type == 1 ? 'cyan' : 'orange'"
                                  outlined
                                >
                                  <template v-if="item.type == 1"
                                    >Site Location</template
                                  >
                                  <template v-else>Billing</template>
                                </v-chip>
                              </v-flex>
                            </v-layout>
                            <v-list-item-title
                              class="text-capitalize font-weight-500 font-size-16"
                              >{{ get_formatted_property(item) }}
                            </v-list-item-title>
                          </v-list-item-content>
                        </template>
                      </v-autocomplete>
                    </v-col>

                    <v-col md="12" class="py-0">
                      <label class="font-weight-600 ml-1 required"
                        >Equipment</label
                      >
                      <v-autocomplete
                        v-model="warrantyOption.equipemt"
                        :items="allEquipemtList"
                        clearable
                        dense
                        flat
                        filled
                        label="Equipment"
                        item-color="cyan"
                        color="cyan"
                        solo
                        disabled
                        :loading="pageLoading"
                        item-text="name"
                        item-value="id"
                        :rules="[
                          validateRules.required(
                            warrantyOption.equipemt,
                            'Equipment'
                          ),
                        ]"
                      >
                        <template v-slot:no-data>
                          <v-list-item>
                            <v-list-item-title
                              v-html="'No Equipment(s) Found.'"
                            ></v-list-item-title>
                          </v-list-item>
                        </template>
                        <template v-slot:item="{ item }">
                          <v-list-item-content>
                            <v-list-item-title
                              class="text-capitalize font-weight-500 font-size-16 max-content-width"
                              >{{ item.name }}</v-list-item-title
                            >
                            <v-list-item-title
                              class="text-capitalize font-weight-500 font-size-16 max-content-width"
                              >{{ item.serial_no }}</v-list-item-title
                            >
                          </v-list-item-content>
                        </template>
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                </template>
                <v-col md="12" v-if="warrantyOption.equipemt">
                  <!-- Equipment Detail -->
                  <v-layout
                    class="nmt-1 bg-quo pb-3 custom-border-bottom"
                    style="margin-bottom: 0.8rem"
                  >
                    <v-flex md2 class="mr-2">
                      <table width="100%">
                        <tr v-if="equipmentInfo">
                          <td class="py-0">
                            <v-avatar size="80">
                              <v-img
                                class="customer-image"
                                width="80"
                                height="80"
                                contain
                                :lazy-src="$defaultImage"
                                :src="
                                  equipmentInfo.image
                                    ? equipmentInfo.image
                                    : $defaultImage
                                "
                              >
                              </v-img>
                            </v-avatar>
                          </td>
                        </tr>
                      </table>
                    </v-flex>
                    <v-flex md4 class="mr-2">
                      <table width="100%" class="mt-2">
                        <tr v-if="equipmentInfo.barcode">
                          <td class="py-0">
                            <label
                              ><span class="font-weight-600">ID:</span>
                              <span>{{ equipmentInfo.barcode }}</span></label
                            >
                          </td>
                        </tr>
                        <tr v-if="equipmentInfo.serial_no">
                          <td class="py-0">
                            <label
                              ><span class="font-weight-600">Serial No.:</span>
                              <span>{{ equipmentInfo.serial_no }}</span></label
                            >
                          </td>
                        </tr>
                        <tr v-if="equipmentInfo.name">
                          <td class="py-0">
                            <label
                              ><span class="font-weight-600">Name:</span>
                              <span>{{ equipmentInfo.name }}</span></label
                            >
                          </td>
                        </tr>
                      </table>
                    </v-flex>
                    <v-flex md6 class="mr-2">
                      <table width="100%" class="mt-2">
                        <tr>
                          <td class="py-0" v-if="equipmentInfo.brand">
                            <label
                              ><span class="font-weight-600">Brand:</span>
                              <span>{{ equipmentInfo.brand }}</span></label
                            >
                          </td>
                          <td class="py-0" v-else>
                            <em class="text-muted">no brand</em>
                          </td>
                        </tr>
                        <tr>
                          <td class="py-0" v-if="equipmentInfo.model">
                            <label
                              ><span class="font-weight-600">Model:</span>
                              <span>{{ equipmentInfo.model }}</span></label
                            >
                          </td>
                          <td class="py-0" v-else>
                            <em class="text-muted">no model</em>
                          </td>
                        </tr>
                        <tr>
                          <td class="py-0" v-if="equipmentInfo.do_no">
                            <label
                              ><span class="font-weight-600">DO No.:</span>
                              <span>{{ equipmentInfo.do_no }}</span></label
                            >
                          </td>
                          <td class="py-0" v-else>
                            <em class="text-muted">no do no.</em>
                          </td>
                        </tr>
                      </table>
                    </v-flex>
                  </v-layout>
                  <!-- Equipment Detail -->

                  <v-layout class="nmt-1 bg-quo">
                    <v-flex
                      md6
                      class="mr-2 custom-border-right"
                      v-if="equipmemntArr && equipmemntArr.contact_person"
                    >
                      <table width="100%">
                        <tr>
                          <td class="font-weight-600">
                            <label>Contact details</label>
                          </td>
                        </tr>
                        <tr
                          v-if="equipmemntArr && equipmemntArr.contact_person"
                        >
                          <td class="py-0">
                            <span
                              class="mr-2"
                              v-if="
                                equipmemntArr &&
                                equipmemntArr.contact_person.display_name
                              "
                            >
                              <v-icon small>mdi-account</v-icon></span
                            >
                            <label>{{
                              equipmemntArr.contact_person.display_name
                            }}</label>
                          </td>
                        </tr>
                        <em v-else class="text-muted ml-2">
                          no contact detail</em
                        >
                        <tr
                          v-if="equipmemntArr && equipmemntArr.contact_person"
                        >
                          <td class="py-0">
                            <span
                              class="mr-2"
                              v-if="
                                equipmemntArr &&
                                equipmemntArr.contact_person.primary_phone
                              "
                            >
                              <v-icon small>mdi-phone</v-icon></span
                            >
                            <label
                              v-if="
                                equipmemntArr &&
                                equipmemntArr.contact_person.primary_phone
                              "
                              >{{
                                equipmemntArr &&
                                equipmemntArr.contact_person.primary_phone
                              }}</label
                            >
                            <em v-else class="text-muted"> no phone number</em>
                          </td>
                        </tr>
                        <tr
                          v-if="equipmemntArr && equipmemntArr.contact_person"
                        >
                          <td class="py-0">
                            <span
                              class="mr-2"
                              v-if="
                                equipmemntArr &&
                                equipmemntArr.contact_person.primary_email
                              "
                            >
                              <v-icon small>mdi-email</v-icon></span
                            >
                            <label
                              v-if="
                                equipmemntArr &&
                                equipmemntArr.contact_person.primary_email
                              "
                              >{{
                                equipmemntArr &&
                                equipmemntArr.contact_person.primary_email
                              }}</label
                            >
                            <em v-else class="text-muted"> no email</em>
                          </td>
                        </tr>
                      </table>
                    </v-flex>
                    <v-flex
                      md6
                      class="mr-2"
                      v-if="equipmemntArr && equipmemntArr.property_address"
                    >
                      <table width="100%">
                        <tr>
                          <td class="font-weight-600">
                            <label>Company Address</label>
                          </td>
                        </tr>
                        <tr
                          v-if="equipmemntArr && equipmemntArr.property_address"
                        >
                          <td class="py-0 d-flex">
                            <span
                              class="mr-2"
                              v-if="
                                equipmemntArr && equipmemntArr.property_address
                              "
                            >
                              <v-icon small>mdi-map-marker</v-icon></span
                            >
                            <label
                              v-if="
                                equipmemntArr && equipmemntArr.property_address
                              "
                            >
                              <span v-if="equipmemntArr?.property_name"
                                >{{ equipmemntArr?.property_name }}<br
                              /></span>
                              {{ equipmemntArr.street_1 }},
                              <br
                                v-if="
                                  equipmemntArr.street_2 ||
                                  equipmemntArr.unit_no
                                "
                              />
                              <template v-if="equipmemntArr.street_2">
                                {{ equipmemntArr.street_2 }},
                              </template>
                              <template v-if="equipmemntArr.unit_no">
                                {{ equipmemntArr.unit_no }},
                              </template>
                              <br />
                              {{ equipmemntArr.country }},
                              {{ equipmemntArr.zip_code }},
                            </label>
                          </td>
                        </tr>
                        <em v-else class="text-muted ml-2">
                          no company address</em
                        >
                      </table>
                    </v-flex>
                  </v-layout>
                </v-col>
                <v-row>
                  <v-col md="6" class="py-0">
                    <label class="font-weight-600 ml-1">Duration</label>
                    <v-text-field
                      dense
                      v-mask="'###'"
                      v-model.trim="warrantyOption.duration"
                      filled
                      label="Duration"
                      solo
                      flat
                      color="cyan"
                      class="pr-2 width-100"
                      v-on:keyup="
                        (e) => updateWarrantyDuration(e, 'warranty_duration')
                      "
                    ></v-text-field>
                  </v-col>
                  <v-col md="6" class="py-0">
                    <label class="font-weight-600 ml-1">Duration Type</label>
                    <v-select
                      :items="warrantyDurationTypes"
                      v-model.trim="warrantyOption.duration_type"
                      dense
                      filled
                      solo
                      flat
                      class="pl-2 pr-2 width-100"
                      label="Duration Type"
                      color="cyan"
                      item-text="text"
                      item-value="value"
                      item-color="cyan"
                      v-on:change="
                        (e) =>
                          updateWarrantyDuration(e, 'warranty_duration_type')
                      "
                    ></v-select>
                  </v-col>
                  <v-col md="6" class="py-0">
                    <label class="font-weight-600 ml-1">Start Date</label>
                    <DatePicker
                      solo
                      :defaultDate="warrantyOption.start_date"
                      :pageLoading="pageLoading"
                      :placeholder="'Start Date'"
                      :minDate="warrantyOption.start_date"
                      v-model="warrantyOption.start_date"
                      v-on:change="
                        (e) => updateWarrantyDuration(e, 'start_date')
                      "
                    ></DatePicker>
                  </v-col>
                  <v-col md="6" class="py-0">
                    <label class="font-weight-600 ml-1">End Date</label>
                    <div class="ml-1 black--text">
                      {{ formatDate(warrantyOption.end_date) }}
                    </div>
                    <DatePicker
                      v-if="false"
                      solo
                      :defaultDate="warrantyOption.end_date"
                      :pageLoading="pageLoading"
                      :placeholder="'End Date'"
                      v-model="warrantyOption.end_date"
                      :minDate="warrantyOption.start_date"
                    ></DatePicker>
                  </v-col>
                  <v-col md="6" class="py-0">
                    <label class="font-weight-600 my-1 required"
                      >Reference No.</label
                    >
                    <v-text-field
                      dense
                      filled
                      :rules="[
                        validateRules.required(
                          warrantyOption.reference,
                          'Reference No.'
                        ),
                      ]"
                      color="cyan"
                      label="Reference No."
                      solo
                      flat
                      v-model.trim="warrantyOption.reference"
                    ></v-text-field>
                  </v-col>
                  <v-col md="6" class="py-0">
                    <label class="font-weight-600 ml-1">Cost</label>
                    <v-text-field
                      type="number"
                      dense
                      filled
                      color="cyan"
                      solo
                      label="Cost"
                      flat
                      v-model.trim="warrantyOption.cost"
                      onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57) || event.charCode==46)"
                    ></v-text-field>
                  </v-col>
                  <v-col md="12" class="py-0">
                    <label class="font-weight-600 ml-1">Description</label>
                    <v-textarea
                      v-model.trim="warrantyOption.description"
                      auto-grow
                      dense
                      filled
                      solo
                      flat
                      color="cyan"
                      label="Description"
                      row-height="20"
                      v-on:keypress="(e) => manageLimit(e)"
                      v-on:paste="(e) => onPaste(e)"
                    ></v-textarea>
                    <div class="text-right">
                      {{
                        warrantyOption.description
                          ? warrantyOption.description.length
                          : 0
                      }}/200
                    </div>
                  </v-col>
                  <v-col md="12" class="py-0">
                    <table
                      width="100%"
                      style="table-layout: fixed"
                      class="my-auto py-0 align-items-center"
                    >
                      <tr
                        v-for="(row, index) in files"
                        :key="`create-visit-attachment-${index}`"
                      >
                        <td class="">
                          <v-file-input
                            hide-details
                            class="px-0"
                            dense
                            filled
                            solo
                            flat
                            v-model="row.file"
                            placeholder="Select File"
                            prepend-icon=""
                            prepend-inner-icon="$file"
                            v-on:change="updateFile(index, $event)"
                            v-on:click:clear="updateFile(index, $event)"
                            color="cyan"
                          />
                        </td>
                        <td class="py-0">
                          <v-text-field
                            hide-details
                            class="px-0"
                            v-model="row.name"
                            placeholder="Name"
                            dense
                            filled
                            solo
                            flat
                            color="cyan"
                          />
                        </td>
                        <td class="px-0 py-0" width="5%" align="center">
                          <v-btn
                            :disabled="files.length < 2"
                            v-on:click="removeFile(index)"
                            icon
                            class="w-100"
                            color="red lighten-1"
                          >
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                        </td>
                      </tr>
                      <tr>
                        <td class="" colspan="3">
                          <v-btn
                            color="cyan white--text"
                            class="custom-bold-button"
                            depressed
                            v-on:click="addMore()"
                            tile
                            >Add More</v-btn
                          >
                        </td>
                      </tr>
                    </table>
                    <!--  <template v-for="(file, index) in files">
                        <v-row :key="index">
                          <v-col
                            lg="5"
                            cols="5"
                            class="my-auto py-0 d-flex align-items-center"
                          >
                            <v-file-input
                              :id="`document-file-${index}`"
                              placeholder="Select File"
                              outlined
                              class="mt-3"
                              prepend-icon=""
                              prepend-inner-icon="mdi-attachment"
                              hide-details
                              v-model="file.file"
                              v-on:change="updateFile(index, $event)"
                              v-on:click:clear="updateFile(index, $event)"
                            ></v-file-input>
                          </v-col>
                          <v-col
                            lg="5"
                            cols="5"
                            class="my-auto py-0 d-flex align-items-center"
                          >
                            <v-text-field
                              :id="`document-name-${index}`"
                              class="mt-3"
                              filled
                              placeholder="File Name"
                              solo
                              flat
                              color="cyan"
                              hide-details
                              v-model="file.name"
                            ></v-text-field>
                          </v-col>
                          <v-col
                            lg="1"
                            cols="1"
                            class="my-auto py-0"
                            style="text-align: center"
                          >
                            <v-btn
                              :disabled="files.length < 2"
                              v-on:click="removeFile(index)"
                              color="red lighten-1 white--text"
                              class="mx-2"
                              icon
                            >
                              <v-icon>mdi-delete</v-icon>
                            </v-btn>
                          </v-col>
                          <v-col lg="1" cols="1" class="my-auto py-0">
                            <v-btn
                              class="mx-2 custom-bold-button white--text"
                              color="cyan"
                              tile
                              depressed
                              v-on:click="addMore()"
                            >
                              <v-icon>mdi-plus</v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </template> -->
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </perfect-scrollbar>
        </v-card-text>
        <v-divider class="my-0"></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <div class="warrant-manage-action">
            <v-btn
              depressed
              :disabled="!formValid || pageLoading"
              :loading="pageLoading"
              v-on:click="update_or_create"
              class="mx-2 custom-bold-button white--text"
              color="cyan"
              >Save
            </v-btn>
            <v-btn
              depressed
              :loading="pageLoading"
              :disabled="pageLoading"
              v-on:click="$emit('close:dialog')"
              class="mx-2 custom-grey-border custom-bold-button"
              >Cancel
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<style scoped>
.v-dialog__content {
  align-items: start;
}
.v-autocomplete:not(.v-input--is-focused).v-select--chips input {
  max-height: 18px;
  padding: 0;
}
.v-text-field--filled > .v-input__control > .v-input__slot {
  min-height: 100%;
}
</style>

<script>
import DatePicker from "@/view/pages/partials/Datepicker.vue";
import {
  /* , PUT, CLEAR_ERROR , */ GET,
  POST,
  CLEAR_ERROR,
  QUERY,
} from "@/core/services/store/request.module";
import ValidationMixin from "@/core/plugins/validation-mixin";
import moment from "moment";
import { toSafeInteger } from "lodash";
import Barcode from "@/view/pages/partials/Barcode.vue";
import CommonMixin from "@/core/plugins/common-mixin";

export default {
  name: "create-or-update-warranty",
  mixins: [ValidationMixin, CommonMixin],
  props: {
    dialogStatus: {
      type: Boolean,
      default: false,
    },
    /*  allCustomerList: {
        type: Array,
        default: () => {
          return new Array();
        },
      },
      allProductList: {
        type: Array,
        default: () => {
          return new Array();
        },
      }, */
    warrantyDetail: {
      type: Object,
      default: () => {
        return new Object();
      },
    },
  },
  components: {
    DatePicker,
    Barcode,
  },
  watch: {
    warrantyDetail: {
      deep: true,
      immediate: true,
      handler() {
        if (this.lodash.isEmpty(this.warrantyDetail) === false) {
          this.warrantyOption.id = this.warrantyDetail.id;
          this.warrantyOption.customer = this.warrantyDetail.type_id;
          this.warrantyOption.equipemt = this.warrantyDetail.service_id;
          this.warrantyOption.cost = this.warrantyDetail.cost;
          this.warrantyOption.warranty_type = this.warrantyDetail.type;
          this.warrantyOption.start_date = moment(
            this.warrantyDetail.warranty_end_date_formatted,
            "YYYY-MM-DD"
          )
            .add(1, "days")
            .format("YYYY-MM-DD");
          this.warrantyOption.end_date =
            this.warrantyDetail.warranty_end_date_formatted;
          this.warrantyOption.duration = toSafeInteger(
            this.warrantyDetail.duration
          );
          this.warrantyOption.duration_type = this.warrantyDetail.duration_type;
          this.warrantyOption.description = this.warrantyDetail.description;
          this.warrantyOption.equipemt_type = this.warrantyDetail.equipemt_type;
          this.warrantyOption.unique_id = this.barcode;
          this.warrantyOption.address = this.warrantyDetail.property
            ? this.warrantyDetail.property
            : 0;
          //console.log(this.warrantyOption.address);
          this.customerId = this.warrantyDetail.type_id;
        }
      },
    },
    dialogStatus: {
      deep: true,
      immediate: true,
      handler(param) {
        if (param) {
          this.getOptions();
          this.getAllCustomers();
          this.getCustomerEquipment();
          this.getEquipment(this.warrantyOption.equipemt);
          this.updateWarrantyDuration(this.warrantyOption.start_date);
        }
      },
    },
  },
  data() {
    return {
      customerId: 0,
      locationId: 0,
      allSiteLocationList: [],
      formValid: true,
      pageLoading: false,
      equipmemntArr: {},
      startDatePicker: null,
      defaultItemWarranty: new Array(),
      allEquipemtList: [],
      allCustomerList: [],
      barcode: null,
      equipmentInfo: {},
      files: [
        {
          file: null,
          name: null,
        },
      ],
      warrantyOption: new Object({
        id: null,
        customer: 0,
        equipemt: 0,
        cost: 0,
        warranty_type: "customer",
        reference: null,
        start_date: null,
        duration: 0,
        duration_type: "day",
        end_date: null,
        unique_id: null,
        description: null,
      }),
      warrantyList: [
        { text: "30 Days", value: "30", type: "day" },
        { text: "6 Months", value: "182", type: "day" },
        { text: "1 Year", value: "365", type: "day" },
        { text: "2 Years", value: "730", type: "day" },
        { text: "3 Years", value: "1095", type: "day" },
      ],
      warrantyDurationTypes: [
        {
          text: "Day(s)",
          value: "day",
        },
        {
          text: "Month(s)",
          value: "month",
        },
        {
          text: "Year(s)",
          value: "year",
        },
      ],
    };
  },
  methods: {
    get_formatted_property(row) {
      let tempArr = [];
      if (row.unit_no) {
        tempArr.push(row.unit_no);
      }
      if (row.street_1) {
        tempArr.push(row.street_1);
      }
      if (row.street_2) {
        tempArr.push(row.street_2);
      }
      if (row.zip_code) {
        tempArr.push(row.zip_code);
      }
      if (row.country_name) {
        tempArr.push(row.country_name);
      }
      return tempArr.join(", ");
    },
    onPaste(e) {
      let coppied = e.clipboardData.getData("Text");
      let preVal = this.warrantyOption.description;
      let finalval = String(preVal) + String(coppied);
      if (Number(finalval.length) > 199) {
        let trimValue = finalval.substring(0, 200);
        this.warrantyOption.description = trimValue;
        e.preventDefault();
      }
    },

    manageLimit(e) {
      if (
        this.warrantyOption.description &&
        this.warrantyOption.description.length > 199
      ) {
        e.preventDefault();
      }
    },

    updateWarrantyDuration(e, type) {
      let warranty_start_date = e;
      if (type != "start_date") {
        warranty_start_date =
          this.warrantyOption && this.warrantyOption.start_date
            ? this.warrantyOption.start_date
            : null;
      }
      if (warranty_start_date) {
        let date = moment(warranty_start_date, "YYYY-MM-DD");

        let duration = this.warrantyOption.duration
          ? toSafeInteger(this.warrantyOption.duration)
          : 0;
        switch (this.warrantyOption.duration_type) {
          case "day":
            date = moment(warranty_start_date, "YYYY-MM-DD").add(duration, "d");
            break;
          case "month":
            date = moment(warranty_start_date, "YYYY-MM-DD").add(duration, "M");
            break;
          case "year":
            date = moment(warranty_start_date, "YYYY-MM-DD").add(duration, "y");
            break;
        }
        date.subtract(1, "days");
        this.warrantyOption.end_date = this.lodash.cloneDeep(
          date.format("YYYY-MM-DD")
        );
      }
    },

    update_or_create() {
      const _this = this;
      if (!_this.$refs.warrantyForm.validate()) {
        return false;
      }
      _this.$store.dispatch(CLEAR_ERROR, {});
      _this.pageLoading = true;
      let formData = new FormData();
      formData.append(
        "type",
        this.warrantyOption.warrantyOption
          ? this.warrantyOption.warrantyOption
          : "customer"
      );
      formData.append(
        "type_id",
        this.warrantyOption.customer ? this.warrantyOption.customer : 0
      );

      formData.append(
        "site_location",
        this.warrantyOption.address ? this.warrantyOption.address : 0
      );

      formData.append(
        "service_id",
        this.warrantyOption.equipemt ? this.warrantyOption.equipemt : 0
      );
      formData.append(
        "duration",
        this.warrantyOption.duration ? this.warrantyOption.duration : 0
      );
      formData.append(
        "duration_type",
        this.warrantyOption.duration_type
          ? this.warrantyOption.duration_type
          : "day"
      );
      if (this.warrantyOption && this.warrantyOption.reference) {
        formData.append(
          "reference",
          this.warrantyOption.reference ? this.warrantyOption.reference : null
        );
      }
      if (this.warrantyOption && this.warrantyOption.start_date) {
        formData.append(
          "start_date",
          this.warrantyOption.start_date ? this.warrantyOption.start_date : null
        );
      }
      if (this.warrantyOption && this.warrantyOption.end_date) {
        formData.append(
          "end_date",
          this.warrantyOption.end_date ? this.warrantyOption.end_date : null
        );
      }
      if (this.warrantyOption && this.warrantyOption.cost) {
        formData.append(
          "cost",
          this.warrantyOption.cost ? this.warrantyOption.cost : 0
        );
      }
      if (this.warrantyOption && this.warrantyOption.description) {
        formData.append(
          "remark",
          this.warrantyOption.description
            ? this.warrantyOption.description
            : null
        );
      }
      if (this.warrantyOption && this.warrantyOption.equipemt_type) {
        formData.append(
          "equipemt_type",
          this.warrantyOption.equipemt_type
            ? this.warrantyOption.equipemt_type
            : null
        );
      }
      if (this.warrantyOption && this.warrantyOption.unique_id) {
        formData.append(
          "unique_id",
          this.warrantyOption.unique_id ? this.warrantyOption.unique_id : null
        );
      }
      for (let i = 0; i < this.files.length; i++) {
        if (this.files && this.files[i] && this.files[i].file) {
          formData.append(`file[${i}][file]`, this.files[i].file);
          formData.append(`file[${i}][name]`, this.files[i].name);
        }
      }

      let requestTYPE = POST;
      let requestURL = `warranty/${this.warrantyOption.id}/renew`;
      this.$store
        .dispatch(requestTYPE, {
          url: requestURL,
          data: formData,
        })
        .then(() => {
          _this.$emit("update:warranty", true);
          _this.$emit("close:dialog");
        })
        .catch((error) => {
          console.log({ error });
        })
        .finally(() => {
          this.pageLoading = false;
        });
    },
    updateFile(index, file, value, data) {
      if (value == "keyword") {
        if (file && file.name) {
          data[index].name = file.name.split(".").slice(0, -1).join(".");
          data[index].suffix = `.${file.name.split(".").pop()}`;
        } else {
          data[index].name = null;
          data[index].suffix = null;
        }
      } else {
        if (file && file.name) {
          this.files[index].name = file.name.split(".").slice(0, -1).join(".");
          this.files[index].suffix = `.${file.name.split(".").pop()}`;
        } else {
          this.files[index].name = null;
          this.files[index].suffix = null;
        }
      }
    },
    getEquipment(id) {
      if (id && id > 0) {
        const _this = this;
        _this.$store
          .dispatch(QUERY, { url: `equipment/${id}` })
          .then(({ data }) => {
            this.equipmentInfo = data;
            this.equipmemntArr = data.property;
          })
          .catch((error) => {
            _this.logError(error);
          });
      }
    },
    addMore() {
      this.files.push({
        file: null,
        name: null,
      });
    },
    getAllCustomers() {
      const _this = this;
      _this.$store
        .dispatch(GET, { url: "customer-list" })
        .then(({ data }) => {
          _this.allCustomerList = data;
        })
        .catch((error) => {
          _this.logError(error);
        });
    },
    getCustomerEquipment() {
      const _this = this;
      _this.$store
        .dispatch(GET, { url: "equipment-list" })
        .then(({ data }) => {
          _this.allEquipemtList = data;
        })
        .catch((error) => {
          _this.logError(error);
        });
    },
    getOptions() {
      const _this = this;
      if (this.customerId) {
        _this.customerId = this.customerId;
      }
      _this.$store
        .dispatch(QUERY, {
          url: "warranty/options",
          data: { customer: this.customerId ? this.customerId : 0 },
        })
        .then(({ data }) => {
          _this.barcode = data;
          this.warrantyOption.unique_id = _this.barcode.barcode;
          _this.allSiteLocationList = data.address ? data.address : [];
        })
        .catch((error) => {
          _this.logError(error);
        });
    },

    removeFile(index) {
      this.files.splice(index, 1);
      if (this.files.length < 1) {
        this.addMore();
      }
    },
    removeWarranty(index) {
      this.defaultItemWarranty.splice(index, 1);
    },
  },
  computed: {
    dialogWidth() {
      return this.lodash.toSafeInteger((document.body.clientWidth / 100) * 60);
    },
  },
};
</script>
